module.exports = __webpack_public_path__ + "img/bgc4.9ae61cad.png";